import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuUnpackagedDeliveryBatchesView } from "src/tenantCustomizations/tenants/mellano/views/luukku/deliveries/MellanoLuukkuUnpackagedDeliveryBatchesView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/unpackagedDeliveryBatches")({
	staticData: { title: "Paketoimattomat toimituserät", legacyViewKey: "mellanoLuukkuUnpackagedDeliveryBatchesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuUnpackagedDeliveryBatchesView />;
}
